module.exports = __webpack_public_path__ + "static/media/03.cfb4727c.png";